import { DiscountStatusTransitionType } from 'interfaces';

export const STATUS_COMMENT_LABEL_MAP: Record<
  DiscountStatusTransitionType,
  string
> = {
  [DiscountStatusTransitionType.REASON_FOR_NON_EXTENSION]:
    'archives.statusComments.reasonForNonExtension',
  [DiscountStatusTransitionType.REASON_FOR_EXTENSION]:
    'archives.statusComments.reasonForExtension',
};
